export class SearchProvince {
    public province: string = '';
  }
  